export enum ESpacing {
  y = 'yZero',
  xxsm = 'xxSmall',
  xsm = 'xSmall',
  sm = 'small',
  md = 'medium',
  lg = 'large',
  xlg = 'xLarge',
  bg = 'big',
  xbg = 'xBig',
  bgr = 'bigger',
  xbgr = 'xBigger',
}
